const API_URL = process.env.REACT_APP_API_URL || '';

export async function validateEmbedToken(token: string | null): Promise<boolean> {
  if (!token) return false;
  try {
    const response = await fetch(`${API_URL}/api/tokens/validate?token=${encodeURIComponent(token)}`);
    if (!response.ok) return false;
    const data = await response.json();
    return data.valid === true;
  } catch {
    return false;
  }
}
